module.exports = __webpack_public_path__ + "img/partfive_pic.c306bc49.png";